import type { HolidayScope } from '../../models/holiday.types';

export const SECTION_TITLE = 'Feriados';
export const SECTION_DESCRIPTION =
    'Bloqueiam o início de férias no próprio feriado e nos dois dias que o antecedem (art. 134 §3º), no calendário de todo colaborador. Os de data fixa definidos por lei — nacionais e de Belo Horizonte — já vêm prontos e não podem ser alterados.';

export const ADD_LABEL = 'Adicionar feriado';
export const EDIT_LABEL = 'Editar';
export const REMOVE_LABEL = 'Remover';
export const YEAR_LABEL = 'Ano';

export const COLUMN_LABELS = {
    date: 'Data',
    name: 'Feriado',
    scope: 'Alcance',
    recurring: 'Repete todo ano',
    actions: 'Ações',
} as const;

export const SCOPE_CLASSES: Record<HolidayScope, string> = {
    national: 'bg-primary-50 text-primary-700',
    state: 'bg-amber-50 text-amber-700',
    municipal: 'bg-emerald-50 text-emerald-700',
};

export const RECURRING_YES = 'Data fixa';
export const LOCKED_BADGE: Record<HolidayScope, string> = {
    national: 'Lei federal',
    state: 'Lei estadual',
    municipal: 'Lei municipal',
};

export const LOCKED_HINT = 'Feriado de data fixa definido por lei — não pode ser editado nem removido.';
export const RECURRING_NO = 'Data móvel';
export const RECURRING_NO_HINT =
    'Muda de ano para ano — precisa ser cadastrada manualmente a cada ano.';

export const EMPTY_MESSAGE = 'Nenhum feriado neste ano.';
export const EMPTY_HINT =
    'Os nacionais de data fixa deveriam aparecer aqui automaticamente.';
export const LOADING_MESSAGE = 'Carregando feriados...';

export const READ_ONLY_HINT = 'Você pode consultar os feriados, mas não editá-los.';

export function buildDuplicateLabel(targetYear: number): string {
    return `Duplicar cadastrados para ${targetYear}`;
}

export const DUPLICATE_HINT =
    'Os nacionais de data fixa já existem em qualquer ano. A duplicação copia só o que foi cadastrado aqui — e as datas móveis (Carnaval, Sexta-feira Santa, Corpus Christi) precisam ser corrigidas depois, porque dependem da Páscoa.';

export function buildRemoveConfirmation(name: string, date: string): string {
    return `Remover "${name}" (${date})? O calendário de férias volta a permitir início nesta véspera.`;
}

export function buildYearOptions(currentYear: number): number[] {
    return [currentYear - 2, currentYear - 1, currentYear, currentYear + 1, currentYear + 2];
}
